<template>
  <v-flex xs12 class="px-0" v-if="!isEditAddressEnabled">
    <v-card class="business-location-card pa-2 mt-2">
      <v-textarea
        :placeholder="$tc('message.bizgainOnboarding.businessLocation')"
        class="pt-0 mt-0"
        name="location"
        v-model="location"
        no-resize
        :rows="2"
        :readonly="true"
        :append-icon="'edit'"
        @click:append="isEditAddressEnabled = !isEditAddressEnabled"
      >
        <template v-if="locationIcon" v-slot:prepend>
          <v-icon>mdi-map-marker</v-icon>
        </template>
      </v-textarea>
    </v-card>
  </v-flex>
  <v-card class="pa-2 mt-2" v-else>
    <v-layout row wrap>
      <v-flex
        xs12
        :class="{
          'mx-3': !$vuetify.breakpoint.xsOnly,
          'mx-2': $vuetify.breakpoint.xsOnly
        }"
      >
        <v-flex xs12>
          <div class="title-style">
            {{ $t('message.bizgainOnboarding.addressLine') }}
          </div>
          <v-text-field
            :placeholder="$tc('message.bizgainOnboarding.addressLine')"
            class="pt-0 mt-0"
            name="addressLine"
            v-model="addressLine"
            autocapitalize="off"
            v-validate="'max:500'"
            @focus="clearErrorByField($event, 'addressLine')"
            :error-messages="
              errors.first('addressLine')
                ? $tc('message.bizgainOnboarding.addressLineValidationMessage')
                : null
            "
            @change="updateLocationObject(true)"
          />
        </v-flex>
        <v-flex
          xs12
          :class="{ 'd-flex': !$vuetify.breakpoint.xsOnly }"
        >
          <v-flex xs12 md6 :class="{ 'pr-3': !$vuetify.breakpoint.xsOnly }">
            <div class="title-style">
              {{ $t('message.bizgainOnboarding.postCode') }}
            </div>
            <v-text-field
              :placeholder="$tc('message.bizgainOnboarding.postCode')"
              class="pt-0 mt-0"
              name="postalCode"
              v-model="postalCode"
              autocapitalize="off"
              v-validate="'required|max:10'"
              data-vv-validate-on="blur"
              @focus="clearErrorByField($event, 'postalCode')"
              @blur="getZipLocation"
              :error-messages="
                errors.first('postalCode')
                  ? $tc('message.bizgainOnboarding.postalCodeValidationMessage')
                  : null
              "
              @change="updateLocationObject(true)"
            />
          </v-flex>
          <v-flex xs12 md6 :class="{ 'pl-3': !$vuetify.breakpoint.xsOnly }">
            <div class="title-style">
              {{ $t('message.bizgainOnboarding.areaName') }}
            </div>
            <v-text-field
              :placeholder="$tc('message.bizgainOnboarding.areaName')"
              class="pt-0 mt-0"
              name="areaName"
              v-model="areaName"
              autocapitalize="off"
              v-validate="'max:200'"
              @focus="clearErrorByField($event, 'areaName')"
              :error-messages="
                errors.first('areaName')
                  ? $tc('message.bizgainOnboarding.areaNameValidationMessage')
                  : null
              "
              @change="updateLocationObject(true)"
            />
          </v-flex>
        </v-flex>
        <v-flex
          xs12
          :class="{ 'd-flex': !$vuetify.breakpoint.xsOnly }"
        >
          <v-flex xs12 md6 :class="{ 'pr-3': !$vuetify.breakpoint.xsOnly }">
            <div class="title-style">
              {{ $t('message.bizgainOnboarding.city') }}
            </div>
            <v-text-field
              :placeholder="$tc('message.bizgainOnboarding.city')"
              class="pt-0 mt-0"
              name="city"
              v-model="city"
              autocapitalize="off"
              v-validate="'required|max:200'"
              data-vv-validate-on="blur"
              @focus="clearErrorByField($event, 'city')"
              :error-messages="
                errors.first('city')
                  ? $tc('message.bizgainOnboarding.cityValidationMessage')
                  : null
              "
              @change="updateLocationObject(true)"
            />
          </v-flex>
          <v-flex xs12 md6 :class="{ 'pl-3': !$vuetify.breakpoint.xsOnly }">
            <div class="title-style">
              {{ $t('message.bizgainOnboarding.state') }}
            </div>
            <v-text-field
              :placeholder="$tc('message.bizgainOnboarding.state')"
              class="pt-0 mt-0"
              name="state"
              v-model="state"
              autocapitalize="off"
              v-validate="'max:200'"
              @focus="clearErrorByField($event, 'state')"
              :error-messages="
                errors.first('state')
                  ? $tc('message.bizgainOnboarding.stateValidationMessage')
                  : null
              "
              @change="updateLocationObject(true)"
            />
          </v-flex>
        </v-flex>
        <v-flex xs12 class="pb-2">
          <v-flex class="pt-3">
            <button type="button" @click="getCurrentLocation">
              <v-icon color="primary" class="pr-1">
                my_location
              </v-icon>
              <span
                class="text-position primary--text"
                :class="{ 'pb-1': $vuetify.breakpoint.xsOnly }"
              >
                {{ $t('message.bizgainOnboarding.useMyLocation') }}
              </span>
            </button>
          </v-flex>
        </v-flex>
      </v-flex>
      <v-flex
        xs12
        md3
        class="pa-2"
        v-if="isSummary"
      >
        <v-flex xs12 :class="{ 'pl-3': !$vuetify.breakpoint.xsOnly }">
          <slot name="button" />
        </v-flex>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { GoogleMapHelper } from 'Features/bizgainOnboarding/helpers/googleMapHelper';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
import clearErrorByField from 'Mixins/clearErrorByField';
const { getGeoLocation } = new ApiService();
import {
  VFlex,
  VTextField,
  VTextarea,
  VLayout,
  VIcon,
  VCard
} from 'vuetify/lib';

export default {
  mixins: [clearErrorByField],
  components: {
    VFlex,
    VTextField,
    VTextarea,
    VLayout,
    VIcon,
    VCard
  },
  props: ['locationIcon', 'existingBusinessLocation', 'isSummary', 'editAddress'],
  data() {
    return {
      location: null,
      isEditAddressEnabled: false,
      addressLine: null,
      postalCode: null,
      areaName: null,
      city: null,
      state: null,
      googleMapHelper: null,
      updatedLocation: null,
      country: null,
      longitude: null,
      latitude: null,
      countryCode: null,
      oldPostalCode: null,
      currencyId: null,
      newCurrencySymbol: null,
      loadingGeoZipLocation: false,
      dxLocationId: null,
      ExistingBusinessLocationInfo: null
    };
  },
  computed: {
    ...mapGetters(['businessLocation', 'roimaticConfiguration'])
  },
  methods: {
    ...mapActions(['updateMessage']),
    async getCurrentLocation() {
      try {
        this.loadingGeoZipLocation = true;
        this.$emit('get-location', this.loadingGeoZipLocation);
        let currentLocationDetails = await this.googleMapHelper.getGoogleCurrentLocationDetails();
        if (currentLocationDetails) {
          this.postalCode = currentLocationDetails.postalCode;
          this.oldPostalCode = currentLocationDetails.postalCode;
          this.areaName = currentLocationDetails.areaName;
          this.city = currentLocationDetails.city;
          this.state = currentLocationDetails.state;
          this.country = currentLocationDetails.country;
          this.latitude = currentLocationDetails.latitude;
          this.longitude = currentLocationDetails.longitude;
          this.addressLine = currentLocationDetails.addressLine;
          if (this.postalCode) {
            this.clearErrorByField(null, 'postalCode');
            let zipLocation = await getGeoLocation(this.postalCode);
            if (zipLocation.currencyId) {
              this.currencyId = zipLocation.currencyId;
            }
            if (zipLocation.currencySymbol) {
              this.newCurrencySymbol = zipLocation.currencySymbol;
            }
            if (zipLocation.id) {
              this.dxLocationId = zipLocation.id;
            }
            if (zipLocation.countryCode) {
              this.countryCode = zipLocation.countryCode;
            }
          }
          this.loadingGeoZipLocation = false;
          this.$emit('get-location', this.loadingGeoZipLocation);
          this.updateLocationObject(true);
          if (this.city) {
            this.clearErrorByField(null, 'city');
          }
        }
      } catch (error) {
        if (typeof error == 'boolean') {
          if (error) {
            this.updateMessage({
              type: 'info',
              message: this.$t(
                'message.bizgainOnboarding.pleasAllowLocationToDetectCurrentLcoation'
              )
            });
          } else {
            this.updateMessage({
              type: 'info',
              message: this.$t(
                'message.bizgainOnboarding.yourBrowserDoesntSupportLocation'
              )
            });
          }
        } else {
          this.updateMessage({
            type: 'error',
            message: this.$t('message.bizgainOnboarding.failedToDetectLocation')
          });
        }
      }
    },
    async mapsInit() {
      this.googleMapHelper = new GoogleMapHelper();
      await this.googleMapHelper.mapInitalize(
        document.getElementById('g-map-container')
      );
    },
    getZipLocation() {
      try {
        if (this.postalCode && this.oldPostalCode != this.postalCode) {
          this.loadingGeoZipLocation = true;
          this.$emit('get-location', this.loadingGeoZipLocation);
          let promise = getGeoLocation(this.postalCode);
          promise.then((zipLocation) => {
            if (zipLocation) {
              if (zipLocation.areaName) {
                this.areaName = zipLocation.areaName;
              }
              if (zipLocation.city) {
                this.city = zipLocation.city;
              }
              if (zipLocation.state) {
                this.state = zipLocation.state;
              }
              if (zipLocation.countryCode) {
                this.countryCode = zipLocation.countryCode;
              }
              this.country = zipLocation.countryName;
              this.dxLocationId = zipLocation.id;
              this.currencyId = zipLocation.currencyId;
              this.newCurrencySymbol = zipLocation.currencySymbol;
            }
            this.oldPostalCode = this.postalCode;
            this.updateLocationObject(true);
            this.loadingGeoZipLocation = false;
            this.$emit('get-location', this.loadingGeoZipLocation);
          });
        }
      } catch (error) {
        this.loadingGeoZipLocation = false;
        this.updateMessage({
          type: 'error',
          message: this.$t(
            'message.bizgainOnboarding.failedToFetchGeoZipLocation'
          )
        });
      }
    },
    updateLocationObject(isLocationUpdate) {
      this.updatedLocation = {
        addressLine: this.addressLine,
        postalCode: this.postalCode,
        areaName: this.areaName,
        city: this.city,
        state: this.state,
        country: this.country,
        longitude: this.longitude,
        latitude: this.latitude,
        countryCode: this.countryCode,
        oldPostalCode: this.oldPostalCode,
        currencyId: this.currencyId,
        newCurrencySymbol: this.newCurrencySymbol,
        dxLocationId: this.dxLocationId
      };
      this.$emit('updated-location', this.updatedLocation, isLocationUpdate);
    },
    getFullAddress() {
      let location = '';
      if (this.addressLine) {
        location += `${this.addressLine} \n`;
      }
      if (this.areaName) {
        location += `${this.areaName}, `;
      }
      if (this.city) {
        location += `${this.city}, `;
      }
      if (this.state) {
        location += `${this.state} `;
      }
      if (this.postalCode) {
        location += `${this.postalCode}`;
      }
      this.location = location.trim();
    },
    setLocation(){
      if(this.roimaticConfiguration && this.roimaticConfiguration.business && this.roimaticConfiguration.business.location){
        this.ExistingBusinessLocationInfo = JSON.parse(
          JSON.stringify(this.roimaticConfiguration.business.location)
        );
        this.addressLine = this.ExistingBusinessLocationInfo.name;
        this.postalCode = this.ExistingBusinessLocationInfo.zip;
        this.areaName = this.ExistingBusinessLocationInfo.areaName;
        this.city = this.ExistingBusinessLocationInfo.city;
        this.state = this.ExistingBusinessLocationInfo.province;
        this.country = this.ExistingBusinessLocationInfo.country;
        this.dxLocationId = this.ExistingBusinessLocationInfo.dxLocationId;
        this.latitude = this.ExistingBusinessLocationInfo.latitude;
        this.longitude = this.ExistingBusinessLocationInfo.longitude;
      }
    },
    clearAllFieldsError(){
      this.clearErrorByField(null, 'addressLine');
      this.clearErrorByField(null, 'postalCode');
      this.clearErrorByField(null, 'areaName');
      this.clearErrorByField(null, 'city');
      this.clearErrorByField(null, 'state');
    }
  },
  created() {
    this.$nextTick(async () => {
      await this.mapsInit();
    });
    if(this.existingBusinessLocation){
      this.setLocation();
      this.updateLocationObject(false);
    }
    else if (this.businessLocation) {
      this.addressLine = this.businessLocation.street;
      this.postalCode = this.businessLocation.zip;
      this.areaName = this.businessLocation.areaName;
      this.city = this.businessLocation.city;
      this.state = this.businessLocation.state;
      this.oldPostalCode = this.postalCode;
      this.country = this.businessLocation.country;
      this.longitude = this.businessLocation.longitude;
      this.latitude = this.businessLocation.latitude;
      this.currencyId = this.businessLocation.currencyId;
      this.dxLocationId = this.businessLocation.dxLocationId;

      this.updateLocationObject(false);
    }
    if (!this.postalCode || !this.city) {
      this.isEditAddressEnabled = true;
    } else {
      this.getFullAddress();
    }
    if(this.editAddress){
      this.isEditAddressEnabled = this.editAddress;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-textarea {
  .v-input__control {
    .v-input__slot {
      margin: 0;
      .v-text-field__slot {
        textarea {
          line-height: 1.38;
          letter-spacing: 0.16px;
          padding: 0;
        }
      }
      &::before {
        border-style: none;
      }
      &::after {
        border-style: none;
      }
    }
    .v-text-field__details {
      display: none;
    }
  }
}
.title-style{
  font-size: 15px;
  font-weight: 500;
  color: #828282;
}
</style>
